import { Col, Form, Input, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  onFinish: (values: any) => void;
  data: any;
};

export const PriceForm: React.FC<FormType> = (props) => {
  const { form, values, onFinish, data } = props;

  const {
    valuePriceLists: { nodes: valuePriceLists },
  } = data;

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={6}>
          <Form.Item name="priceListId" label="Price List" rules={[{ required: true, message: "is required" }]}>
            <Select>
              {valuePriceLists.map((value: any) => (
                <Select.Option key={value.id} value={value.id}>
                  {value.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="wholesale" label="Wholesale" rules={[{ required: true, message: "is required" }]}>
            <Input prefix="€" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="wholesalePromo" label="Wholesale Promo">
            <Input prefix="€" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="retail" label="Retail">
            <Input prefix="€" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
